import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import {
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import {
  BoxFill,
  CalculatorFill,
  Cash,
  CheckCircleFill,
  CreditCardFill,
  Dropbox,
  EyeFill,
  FloppyFill,
  PencilFill,
  PlusCircleFill,
  Search,
  TrashFill,
  XCircleFill,
} from 'react-bootstrap-icons'
import Navbar from '../../../components/navbar/navbar'
import { CustomButton } from '../../CustomButton'
import { CustomPriceInput } from '../../CustomPriceInput'

import {
  addDays,
  addMonths,
  format,
  getDate,
  parseISO,
  setDate,
  toDate,
} from 'date-fns'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import apinode from '../../../services/apinode'
import PedidosCompraService from '../../../services/database/PedidosCompraService'
import PessoasService from '../../../services/database/PessoasService'
import ProdutosService from '../../../services/database/ProdutosService'
import { adaptValue } from '../../../utils/adaptValue'
import { formatPrice } from '../../../utils/formatPrice'
import { CustomSpinner } from '../../CustomSpinner'

import { useCommand } from '../../../hooks/useCommand'
import WmsConfBonusService from '../../../services/database/WmsConfBonusService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { CustomInputDate } from '../../CustomInputDate'
import {
  CenterLoading,
  CondicaoPagamento,
  Container,
  Fixed,
  ResultsCustomers,
  ResultsProducts,
  Title,
} from './styles'

export const FormPedidosCompra = forwardRef(
  (
    { title, onSubmit, isLoadingRequest, isLoadingOrder, idPedidoCompra },
    ref,
  ) => {
    const [order, setOrder] = useState({
      pes_cnpj_cpf: '',
      cod_pessoa: '',
      cliente: '',
      data: format(new Date(), 'yyyy-MM-dd'),
      totalpedido: '',
      outrosvalores: '',
      cod_vendedor: '',
      tipo_pedido: 'compra',
      user_creator: localStorage.idusuario,
      detalhes_pedido: '',
      idpedidoloja: '',
    })
    const [products, setProducts] = useState([])
    const [duplicatas, setDuplicatas] = useState([])

    const [productsFound, setProductsFound] = useState([])
    const [isLoadingProducts, setIsLoadingProducts] = useState({})
    const [isModalSelectProductOpen, setIsModalSelectProductOpen] =
      useState(false)

    const [isSentWMSLoading, setIsSentWMSLoading] = useState(false)

    const [oldValoresUnitario, setOldValoresUnitario] = useState([])

    const [currentIndex, setCurrentIndex] = useState(null)

    const [sellers, setSellers] = useState([])
    const [isLoadingSellers, setIsLoadingSellers] = useState(false)

    const [customers, setCustomers] = useState([])
    const [isLoadingCustomers, setIsLoadingCustomers] = useState(false)

    const [diasParcelas, setDiasParcelas] = useState('')

    const [isLoadindLancarContas, setIsLoadindLancarContas] = useState(false)
    const [isLoadindLancarEstoque, setIsLoadindLancarEstoque] = useState(false)
    const [isLoadingEstornarEstoque, setIsLoadindEstornarEstoque] =
      useState(false)
    const [isLoadingDeleteProduct, setIsLoadingDeleteProduct] = useState(false)

    const [isButtonCalcularEnable, setIsButtonCalcularEnable] = useState(true)
    const [isButtonResetarEnable, setIsButtonResetarEnable] = useState(false)

    const [isLoadingDeleteDuplicata, setIsLoadingDeleteDuplicata] = useState({})

    const [isEditMode, setIsEditMode] = useState({})

    const [tipoDuplicatas, setTipoDuplicatas] = useState('dias')
    const [quantidadeParcelas, setQuantidadeParcelas] = useState('')
    const [diaDoMes, setDiaDoMes] = useState('')

    const [fromDate, setFromDate] = useState(new Date())

    const navigate = useNavigate()

    const isSaveButtonDisabled =
      products.length === 0 ||
      !order.cliente ||
      products.every(
        (product) =>
          !product.descricao || !product.quantidade || !product.valorunitario,
      )

    //? Pesquisa pelos produtos
    async function handleSearchProducts(search, index) {
      try {
        setIsLoadingProducts((prevState) => ({
          ...prevState,
          [index]: true,
        }))

        const data = await ProdutosService.getAll(search)

        if (data.length === 0) {
          return toast.error('Não foi possível encontrar o produto!')
        }

        setProductsFound(!Array.isArray(data) ? [data] : data)
        setCurrentIndex(index)
        setIsModalSelectProductOpen(true)
      } catch (err) {
        console.log(`Erro ao procurar cliente: ${err}`)
        toast.error(`Não foi possível procurar cliente!`)
      } finally {
        setIsLoadingProducts((prevState) => ({
          ...prevState,
          [index]: false,
        }))
      }
    }

    //? Acrescenta o valor de outras despesas em cada valor unitário dos produtos
    function handleAddExtraValue() {
      const percentage =
        (adaptValue(order.outrosvalores) / adaptValue(order.totalpedido)) * 100

      for (const product of products) {
        setOldValoresUnitario((prevState) => [
          ...prevState,
          {
            valorunitario: product.valorunitario,
          },
        ])
      }

      products.forEach((product, index) => {
        const valorunitario = adaptValue(product.valorunitario)
        const valorAdicional = valorunitario * (percentage / 100)

        const newValorUnitario =
          parseFloat(valorunitario) + parseFloat(valorAdicional)

        setProducts((prevState) =>
          prevState.with(index, {
            ...product,
            valorunitario: newValorUnitario,
          }),
        )
      })

      setIsButtonCalcularEnable(false)
      setIsButtonResetarEnable(true)
    }

    async function handleSendWMS(idPedidoCompra) {
      try {
        setIsSentWMSLoading(true)

        const num_bonus = await WmsConfBonusService.create(idPedidoCompra)

        toast.success(`Bônus criado com ID ${num_bonus}`)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível criar o bônus WMS')
      } finally {
        setIsSentWMSLoading(false)
      }
    }

    //? Remove o valor de outras despesas em cada valor unitário dos produtos
    function handleRemoveExtraValue() {
      setProducts((prevState) =>
        prevState.map((product, index) => {
          return {
            ...product,
            valorunitario: oldValoresUnitario[index].valorunitario,
          }
        }),
      )

      setOldValoresUnitario([])

      setOrder((prevState) => ({
        ...prevState,
        outrosvalores: '',
      }))

      setIsButtonCalcularEnable(true)
      setIsButtonResetarEnable(false)
    }

    //? Deleta a duplicata
    async function handleDeleteDuplicata(duplicata, index) {
      if (duplicata.new === true) {
        setDuplicatas((prevState) =>
          prevState.filter((d) => d.codigo !== duplicata.codigo),
        )
      } else {
        try {
          setIsLoadingDeleteDuplicata((prevState) => ({
            ...prevState,
            [index]: true,
          }))

          await PedidosCompraService.deleteDuplicata(duplicata.codigo)

          setDuplicatas((prevState) =>
            prevState.filter((d) => d.codigo !== duplicata.codigo),
          )
          toast.success(`Parcela deletada com sucesso!`)
        } catch (err) {
          console.log(`Erro ao deletar duplicata: ${err}`)
          toast.error(`Não foi possível deletar a duplicata!`)
        } finally {
          setIsLoadingDeleteDuplicata((prevState) => ({
            ...prevState,
            [index]: false,
          }))
        }
      }
    }

    function gerarParcelas() {
      const dataPedido = fromDate

      const valorParcela = order.totalpedido / quantidadeParcelas

      setDuplicatas([])

      for (let dia = 1; dia <= Number(quantidadeParcelas); dia++) {
        let proximaData = null

        if (Number(diaDoMes) > getDate(dataPedido)) {
          proximaData = addMonths(dataPedido, dia - 1)
        } else {
          proximaData = addMonths(dataPedido, dia)
        }

        proximaData = setDate(proximaData, Number(diaDoMes))

        setDuplicatas((prevState) => [
          ...prevState,
          {
            codigo: Math.random(),
            num_parcela: dia,
            data: format(proximaData, 'yyyy-MM-dd'),
            valor: formatPrice(valorParcela),
            obs: '',
            new: true,
          },
        ])
      }
    }

    //? Lança contas a pagar
    async function handleLancarContasPagar() {
      try {
        setIsLoadindLancarContas(true)

        const duplicatasFormatted = duplicatas.map((duplicata) => {
          return {
            ...duplicata,
            dataDuplicata: toDate(parseISO(duplicata.data)).toString(),
            data: order.data,
            valor: adaptValue(duplicata.valor),
          }
        })

        await PedidosCompraService.lancarContasPagar({
          idPedidoCompra: idPedidoCompra,
          duplicatas: duplicatasFormatted,
        })

        toast.success(`Contas a pagar lançadas com sucesso!`)
      } catch (err) {
        return sendErrorApiMessage(err, 'Erro ao lançar contas a pagar!')
      } finally {
        setIsLoadindLancarContas(false)
      }
    }

    //? Lança estoque
    async function handleLancarEstoque() {
      try {
        setIsLoadindLancarEstoque(true)

        await PedidosCompraService.lancarEstoque({
          idPedidoCompra,
          products,
        })

        toast.success(`Estoque lançado com sucesso!`)
      } catch (err) {
        sendErrorApiMessage(err, 'Erro ao lançar estoque!')
      } finally {
        setIsLoadindLancarEstoque(false)
      }
    }

    //? Estorna estoque
    async function handleEstornarEstoque() {
      try {
        setIsLoadindEstornarEstoque(true)

        await PedidosCompraService.estornarEstoque({
          idPedidoCompra,
          products,
        })

        toast.success(`Estoque estornado com sucesso!`)
      } catch (err) {
        if (err?.response?.data) {
          return toast.error(err.response.data.message)
        }

        return toast.error(`Erro ao estornar estoque!`)
      } finally {
        setIsLoadindEstornarEstoque(false)
      }
    }

    //? Adiciona um novo produto
    function handleAddProduct() {
      setProducts((prevState) => [
        ...prevState,
        {
          id: Math.random(),
          codigo: '',
          descricao: '',
          quantidade: '',
          valorunitario: '',
          valor_total_item: '',
          new: true,
        },
      ])
    }

    //? Remove o produto pelo id
    async function handleRemoveProduct(productToDelete) {
      if (productToDelete.new === false) {
        try {
          setIsLoadingDeleteProduct(true)

          await PedidosCompraService.deleteProduct(productToDelete.id)

          setProducts((prevState) =>
            prevState.filter((p) => p.id !== productToDelete.id),
          )

          toast.success(`Produto deletado com sucesso!`)
        } catch (err) {
          console.log(`Erro ao deletar o produto: ${err}`)
          toast.error(`Erro ao deletar o produto!`)
        } finally {
          setIsLoadingDeleteProduct(false)
        }
      } else {
        setProducts((prevState) =>
          prevState.filter((p) => p.id !== productToDelete.id),
        )
      }
    }

    //? Altera o estado de pedido
    function handleChangeOrder(e) {
      const { name, value } = e.target

      setOrder((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }

    //? Seleciona o produto
    function handleSelectProduct(productFound) {
      const product = products[currentIndex]

      setProducts((prevState) =>
        prevState.with(currentIndex, {
          ...product,
          quantidade: '0',
          codigo: productFound.SKU,
          descricao: productFound.DESCRICAO,
          valorunitario: productFound.PRECOCUSTO,
        }),
      )

      setIsModalSelectProductOpen(false)
      setCurrentIndex(null)
    }

    //? Altera o estado do array de produtos
    function handleChangeProduct(e, index) {
      const { name, value } = e.target
      const product = products[index]

      setProducts((prevState) =>
        prevState.with(index, {
          ...product,
          [name]: value,
        }),
      )
    }

    //? Pesquisa pelos clientes
    async function handleSearchCustomers(search) {
      try {
        setIsLoadingCustomers(true)

        const customersData = await PessoasService.getBySearch({
          search,
        })

        if (customersData.length === 0) {
          return toast.error('Não foi possível encontrar o cliente!')
        }

        setCustomers(customersData)
      } catch (err) {
        console.log(`Erro ao procurar cliente: ${err}`)
        toast.error(`Não foi possível procurar cliente!`)
      } finally {
        setIsLoadingCustomers(false)
      }
    }

    //? Seleciona o cliente
    function handleSelectCustomer(customer) {
      setOrder((prevState) => ({
        ...prevState,
        cliente: customer.pes_razao,
        pes_cnpj_cpf: customer.pes_cnpj_cpf,
        cod_pessoa: customer.cod_pessoa,
      }))

      setCustomers([])
    }

    //? Carrega os vendedores
    async function loadSellers() {
      try {
        setIsLoadingSellers(true)

        const response = await apinode.get(
          `vendedores/vendedor?conta=${localStorage.idconta}`,
        )

        setSellers(response.data)
      } catch (err) {
        console.log(`Erro ao carregar os vendedores: ${err}`)
        toast.error('Não foi possível carregar os vendedores!')
      } finally {
        setIsLoadingSellers(false)
      }
    }

    //? Atualiza o valor total dos produtos
    const updateTotalValueProducts = useCallback(() => {
      products.map((product, index) => {
        if (product.quantidade && product.valorunitario) {
          const totalValue = adaptValue(
            product.quantidade * adaptValue(product.valorunitario),
          )

          if (totalValue !== adaptValue(product.valor_total_item)) {
            setProducts((prevState) =>
              prevState.with(index, {
                ...product,
                valor_total_item: String(totalValue),
              }),
            )
          }
        }
      })
    }, [products])

    //? Atualiza o valor total do pedido
    const updateTotalOrder = useCallback(() => {
      const totalOrder = products.reduce((acc, product) => {
        acc = acc + adaptValue(product.valor_total_item)

        return acc
      }, 0)

      setOrder((prevState) => ({
        ...prevState,
        totalpedido: String(totalOrder),
      }))
    }, [products])

    //? Adiciona uma duplicata
    function handleAddDuplicatas() {
      const dias = diasParcelas.trim().split(',')

      const dataPedido = fromDate

      const valorParcela = order.totalpedido / dias.length

      setDuplicatas([])

      dias.map((dia, index) => {
        if (dia.length <= 3) {
          const proximoDia = addDays(dataPedido, Number(dia - 1))

          setDuplicatas((prevState) => [
            ...prevState,
            {
              codigo: Math.random(),
              num_parcela: index + 1,
              data: format(proximoDia, 'yyyy-MM-dd'),
              valor: formatPrice(valorParcela),
              obs: '',
              new: true,
            },
          ])
        } else {
          toast.error('Dias inválidos ou vírgulas faltando!')
        }
      })
    }

    useImperativeHandle(
      ref,
      () => ({
        setDataForm: (pedidoCompra, productsOrder, duplicatasOrder) => {
          const {
            cliente,
            cod_vendedor,
            data,
            outrosvalores,
            tipo_pedido,
            totalpedido,
            detalhes_pedido,
            idpedidoloja,
            cod_pessoa,
            pes_cnpj_cpf,
          } = pedidoCompra

          setOrder((prevState) => ({
            ...prevState,
            cliente: cliente || '',
            cod_vendedor: cod_vendedor || null,
            data,
            outrosvalores: outrosvalores || '',
            tipo_pedido: tipo_pedido || '',
            totalpedido: totalpedido || '',
            detalhes_pedido: detalhes_pedido || '',
            idpedidoloja: idpedidoloja || '',
            cod_pessoa: cod_pessoa || '',
            pes_cnpj_cpf: pes_cnpj_cpf || '',
          }))

          const duplicatasFormatted = duplicatasOrder.map((duplicataOrder) => ({
            ...duplicataOrder,
            data: format(duplicataOrder.data, 'yyyy-MM-dd'),
          }))

          setProducts(productsOrder)
          setDuplicatas(duplicatasFormatted)
        },
        getDataForm: () => {
          const duplicatasFormatted = duplicatas.map((duplicata) => ({
            ...duplicata,
            data: toDate(parseISO(duplicata.data)).toString(),
          }))

          return {
            order,
            products,
            duplicatas: duplicatasFormatted,
          }
        },
      }),
      [duplicatas, order, products],
    )

    useCommand(handleAddProduct, ['ctrl', 'a'])

    useEffect(() => {
      updateTotalOrder()
    }, [updateTotalOrder])

    useEffect(() => {
      updateTotalValueProducts()
    }, [updateTotalValueProducts])

    useEffect(() => {
      loadSellers()
    }, [])

    return (
      <div ref={ref}>
        {isLoadingOrder ? (
          <CenterLoading>
            <CustomSpinner />
            <h1>Carregando Pedido de Compra... </h1>
          </CenterLoading>
        ) : (
          <>
            <Navbar />

            <Container className="mt-page">
              <Title>{title}</Title>

              <div>
                <Row>
                  <Col>
                    <Form.Label>Nome Cliente/Fornecedor</Form.Label>

                    <Form.Control
                      name="cliente"
                      className="mb-3"
                      required
                      placeholder="João da Silva"
                      value={order.cliente}
                      onChange={handleChangeOrder}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchCustomers(order.cliente)
                        }
                      }}
                    />
                  </Col>

                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                    }}
                  >
                    <CustomButton
                      title="Procurar"
                      className="mb-3"
                      isLoading={isLoadingCustomers}
                      isLoadingText={'Procurando...'}
                      onClick={() => handleSearchCustomers(order.cliente)}
                      isDisabled={order.cliente.length === 0}
                    >
                      <EyeFill />
                    </CustomButton>
                  </Col>
                </Row>

                {customers.length > 0 && (
                  <Row>
                    <ResultsCustomers>
                      {customers.map((customer) => (
                        <article
                          key={customer.cod_pessoa}
                          onClick={() => handleSelectCustomer(customer)}
                        >
                          <h1>{customer.pes_razao}</h1>
                          <p>Código: {customer.cod_pessoa}</p>
                        </article>
                      ))}
                    </ResultsCustomers>
                  </Row>
                )}

                <Row>
                  <Col>
                    <Form.Label>Data</Form.Label>
                    <Form.Control
                      name="data"
                      className="mb-3"
                      type="date"
                      value={order.data}
                      onChange={handleChangeOrder}
                    />
                  </Col>

                  <Col>
                    <Form.Label>Total do Pedido</Form.Label>
                    <CustomPriceInput
                      name="totalpedido"
                      className="mb-3"
                      placeholder="R$ 0,00"
                      disabled
                      value={order.totalpedido}
                      onChange={handleChangeOrder}
                    />
                  </Col>

                  <Col>
                    <Form.Label>Outros Valores</Form.Label>
                    <CustomPriceInput
                      name="outrosvalores"
                      className="mb-3"
                      placeholder="R$ 0,00"
                      value={order.outrosvalores}
                      onChange={handleChangeOrder}
                    />
                  </Col>

                  <Col
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                    }}
                  >
                    <CustomButton
                      title="Calcular"
                      onClick={handleAddExtraValue}
                      className="mb-3"
                      disabled={!isButtonCalcularEnable || !order.outrosvalores}
                    >
                      <CalculatorFill />
                    </CustomButton>

                    <CustomButton
                      title="Resetar Valores"
                      onClick={handleRemoveExtraValue}
                      className="mb-3"
                      disabled={!isButtonResetarEnable}
                    >
                      <CalculatorFill />
                    </CustomButton>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Vendedor</Form.Label>
                    <Form.Select
                      name="cod_vendedor"
                      className="mb-3"
                      value={order.cod_vendedor}
                      required
                      onChange={handleChangeOrder}
                      disabled={isLoadingSellers}
                    >
                      <option value="">
                        {isLoadingSellers
                          ? 'Carregando...'
                          : 'Selecione um vendedor'}
                      </option>
                      {sellers.map((seller) => (
                        <option
                          key={seller.COD_PESSOA}
                          value={seller.COD_PESSOA}
                        >
                          {seller.PES_RAZAO}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col>
                    <Form.Label>Tipo Pedido</Form.Label>
                    <Form.Select
                      name="tipo_pedido"
                      value={order.tipo_pedido}
                      onChange={handleChangeOrder}
                      disabled
                    >
                      <option value="compra">Compra</option>
                    </Form.Select>
                  </Col>
                </Row>

                <>
                  {products.length > 0 && (
                    <Table
                      striped
                      bordered
                      hover
                    >
                      <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Produto</th>
                          <th>Qtd</th>
                          <th>Valor Unit.</th>
                          <th>Valor Total</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((product, index) => (
                          <tr key={product.id}>
                            <td
                              style={{
                                width: 140,
                              }}
                            >
                              <Form.Control
                                name="codigo"
                                disabled
                                value={product.codigo}
                                onChange={(e) => handleChangeProduct(e, index)}
                              />
                            </td>

                            <td
                              style={{
                                display: 'flex',
                              }}
                            >
                              <Form.Control
                                name="descricao"
                                value={product.descricao}
                                onChange={(e) => handleChangeProduct(e, index)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    handleSearchProducts(
                                      product.descricao,
                                      index,
                                    )
                                  }
                                }}
                              />

                              <CustomButton
                                onClick={() =>
                                  handleSearchProducts(product.descricao, index)
                                }
                                isLoading={isLoadingProducts[index]}
                              >
                                <Search />
                              </CustomButton>

                              {isModalSelectProductOpen && (
                                <ModalSelectProduct
                                  products={productsFound}
                                  isOpen={isModalSelectProductOpen}
                                  onClose={() =>
                                    setIsModalSelectProductOpen(false)
                                  }
                                  onSelectProduct={(product) =>
                                    handleSelectProduct(product)
                                  }
                                />
                              )}
                            </td>

                            <td
                              style={{
                                width: 75,
                              }}
                            >
                              <Form.Control
                                name="quantidade"
                                value={product.quantidade}
                                onChange={(e) => handleChangeProduct(e, index)}
                              />
                            </td>

                            <td
                              style={{
                                width: 140,
                              }}
                            >
                              <CustomPriceInput
                                name="valorunitario"
                                value={product.valorunitario}
                                onChange={(e) => handleChangeProduct(e, index)}
                              />
                            </td>

                            <td
                              style={{
                                width: 140,
                              }}
                            >
                              <CustomPriceInput
                                name="valor_total_item"
                                value={product.valor_total_item}
                                onChange={(e) => handleChangeProduct(e, index)}
                                disabled
                              />
                            </td>

                            <td
                              style={{
                                width: 100,
                              }}
                            >
                              <CustomButton
                                color="#e61616"
                                onClick={() => handleRemoveProduct(product)}
                                isLoading={isLoadingDeleteProduct}
                              >
                                <TrashFill />
                              </CustomButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}

                  <CustomButton
                    title="Adicionar Produto"
                    onClick={handleAddProduct}
                  >
                    <PlusCircleFill />
                  </CustomButton>
                </>

                <CondicaoPagamento>
                  <Title>Condição de Pagamento</Title>
                  <Row>
                    <article
                      style={{
                        display: 'flex',
                        gap: 15,
                        marginBottom: 10,
                      }}
                    >
                      <Form.Check
                        checked={tipoDuplicatas === 'dias'}
                        label="Dias"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setTipoDuplicatas('dias')
                          }
                        }}
                      />

                      <Form.Check
                        checked={tipoDuplicatas === 'parcelas'}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setTipoDuplicatas('parcelas')
                          }
                        }}
                        label="Parcelas"
                      />
                    </article>
                  </Row>

                  <>
                    <label
                      htmlFor="diasParcelas"
                      className="form-label"
                    >
                      A partir da data
                    </label>

                    <Row xs={6}>
                      <Col>
                        <CustomInputDate
                          selected={fromDate}
                          onChange={setFromDate}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </>

                  {tipoDuplicatas === 'dias' ? (
                    <Row
                      className="mt-3"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                      }}
                    >
                      <Col>
                        <Form.Label>
                          Dias para as Parcelas (separados por vírgula):
                        </Form.Label>
                        <Form.Control
                          placeholder="2,5,10"
                          value={diasParcelas}
                          onChange={(e) => setDiasParcelas(e.target.value)}
                        />
                      </Col>

                      <Col>
                        <CustomButton
                          title="Gerar Parcelas"
                          onClick={handleAddDuplicatas}
                          isDisabled={
                            !order.data ||
                            !order.totalpedido ||
                            order.totalpedido === '0' ||
                            !diasParcelas
                          }
                        >
                          <CreditCardFill />
                        </CustomButton>
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <Row className="mt-3">
                        <Col>
                          <Form.Label>Quantidade de Parcelas</Form.Label>
                          <Form.Control
                            value={quantidadeParcelas}
                            onChange={(e) =>
                              setQuantidadeParcelas(e.target.value)
                            }
                            placeholder="Ex: 10"
                          />
                        </Col>

                        <Col>
                          <Form.Label>Dia do Mês</Form.Label>
                          <Form.Control
                            value={diaDoMes}
                            onChange={(e) => setDiaDoMes(e.target.value)}
                            placeholder="Ex: 15"
                          />
                        </Col>

                        <Col
                          style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                          }}
                        >
                          <CustomButton
                            title="Gerar Parcelas"
                            onClick={gerarParcelas}
                          >
                            <CreditCardFill />
                          </CustomButton>
                        </Col>
                      </Row>
                    </>
                  )}

                  {duplicatas.length > 0 && (
                    <div
                      style={{
                        marginTop: 30,
                      }}
                    >
                      <Title>Parcelas: </Title>

                      <Table>
                        <thead>
                          <tr>
                            <td>Parcela</td>
                            <td>Vencimento</td>
                            <td>Valor</td>
                            <td>Anotações</td>
                            <td>Ações</td>
                          </tr>
                        </thead>
                        <tbody>
                          {duplicatas.map((duplicata, index) => (
                            <tr key={duplicata.num_parcela}>
                              <td>{duplicata.num_parcela}</td>

                              <td>
                                <Form.Control
                                  type="date"
                                  value={duplicata.data}
                                  onChange={(e) =>
                                    setDuplicatas((prevState) =>
                                      prevState.with(index, {
                                        ...prevState[index],
                                        data: e.target.value,
                                      }),
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <CustomPriceInput
                                  value={duplicata.valor}
                                  onChange={(e) =>
                                    setDuplicatas((prevState) =>
                                      prevState.with(index, {
                                        ...prevState[index],
                                        valor: e.target.value,
                                      }),
                                    )
                                  }
                                  disabled={!isEditMode[index]}
                                />
                              </td>
                              <td>
                                <Form.Control
                                  name="obs"
                                  value={duplicata.obs || ''}
                                  onChange={(e) =>
                                    setDuplicatas((prevState) =>
                                      prevState.with(index, {
                                        ...prevState[index],
                                        obs: e.target.value,
                                      }),
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: 'flex',
                                  }}
                                >
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip>Editar Valor da Parcela</Tooltip>
                                    }
                                  >
                                    <CustomButton
                                      color={
                                        !isEditMode[index] ? 'orange' : 'green'
                                      }
                                      onClick={() =>
                                        !isEditMode[index]
                                          ? setIsEditMode((prevState) => ({
                                              ...prevState,
                                              [index]: true,
                                            }))
                                          : setIsEditMode((prevState) => ({
                                              ...prevState,
                                              [index]: false,
                                            }))
                                      }
                                    >
                                      {!isEditMode[index] ? (
                                        <PencilFill />
                                      ) : (
                                        <CheckCircleFill />
                                      )}
                                    </CustomButton>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    overlay={<Tooltip>Deletar Parcela</Tooltip>}
                                  >
                                    <CustomButton
                                      color="red"
                                      isLoading={
                                        isLoadingDeleteDuplicata[index]
                                      }
                                      onClick={() =>
                                        handleDeleteDuplicata(duplicata, index)
                                      }
                                    >
                                      <TrashFill />
                                    </CustomButton>
                                  </OverlayTrigger>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </CondicaoPagamento>

                <Row
                  xs={4}
                  className="mb-3"
                >
                  <Col>
                    <Form.Label>ID Pedido Loja</Form.Label>
                    <Form.Control
                      name="idpedidoloja"
                      value={order.idpedidoloja}
                      onChange={handleChangeOrder}
                    />
                  </Col>
                </Row>

                <Form.Label>Observações Internas</Form.Label>
                <Form.Control
                  name="detalhes_pedido"
                  value={order.detalhes_pedido}
                  onChange={handleChangeOrder}
                  as="textarea"
                  rows={3}
                  style={{
                    marginBottom: 100,
                  }}
                />

                <Fixed>
                  <CustomButton
                    title="Salvar"
                    color="#00a411"
                    onClick={onSubmit}
                    isLoading={isLoadingRequest}
                    isLoadingText="Salvando..."
                    isDisabled={isSaveButtonDisabled}
                  >
                    <FloppyFill />
                  </CustomButton>

                  {idPedidoCompra && (
                    <CustomButton
                      title="Lançar Contas a Pagar"
                      isDisabled={duplicatas.length === 0}
                      onClick={handleLancarContasPagar}
                      color="#005d0f"
                      isLoading={isLoadindLancarContas}
                      isLoadingText={'Lançando...'}
                    >
                      <Cash />
                    </CustomButton>
                  )}

                  {idPedidoCompra && (
                    <CustomButton
                      title="Lançar Estoque"
                      color=" #e97203 "
                      onClick={handleLancarEstoque}
                      isDisabled={products.length === 0}
                      isLoading={isLoadindLancarEstoque}
                      isLoadingText={'Lançando...'}
                    >
                      <BoxFill />
                    </CustomButton>
                  )}

                  {idPedidoCompra && (
                    <CustomButton
                      title="Criar Bônus de Entrada"
                      color="#2049ff"
                      onClick={() => handleSendWMS(idPedidoCompra)}
                      isLoading={isSentWMSLoading}
                      isLoadingText="Enviando..."
                    >
                      <BoxFill size={16} />
                    </CustomButton>
                  )}

                  {idPedidoCompra && (
                    <CustomButton
                      title="Estornar Itens"
                      color="#03a0e9"
                      onClick={handleEstornarEstoque}
                      isDisabled={products.length === 0}
                      isLoading={isLoadingEstornarEstoque}
                      isLoadingText="Estornando..."
                    >
                      <Dropbox />
                    </CustomButton>
                  )}

                  <CustomButton
                    title="Cancelar"
                    color="#d10000"
                    onClick={() => {
                      navigate('/pedidos-compra')
                    }}
                  >
                    <XCircleFill />
                  </CustomButton>
                </Fixed>
              </div>
            </Container>
          </>
        )}
      </div>
    )
  },
)

function ModalSelectProduct({ isOpen, onClose, products, onSelectProduct }) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Selecione o produto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ResultsProducts>
          {products.map((product) => (
            <article
              key={product?.CODPRODUTO}
              onClick={() => onSelectProduct(product)}
            >
              <h1>{product?.DESCRICAO}</h1>
              <p>SKU: {product?.SKU}</p>
            </article>
          ))}
        </ResultsProducts>
      </Modal.Body>
    </Modal>
  )
}
